import { Component, OnInit } from '@angular/core';
import { Column } from 'exceljs';
import { PlayerListColumn } from '../shared/player-list/player-list-column';
import { AsianPaintsService } from './asian-paints.service';

@Component({
  selector: 'app-asian-paints',
  templateUrl: './asian-paints.component.html',
  styleUrls: ['./asian-paints.component.scss'],
})
export class AsianPaintsComponent implements OnInit {
  currentTab = 'Scientific Rigour';
  scientificRigourColumns: PlayerListColumn[] = [
    {
      name: 'Employee Id',
      key: 'employeeId',
    },
    {
      name: 'Name',
      key: 'name',
    },
    {
      name: 'Highest Score',
      key: 'highestScore',
      type: 'number',
    },
    {
      name: 'Completed Date',
      key: 'completedAt',
      type: 'string',
      formatter: '',
    },
  ];
  scientificRigourPlayers$ = this._asianPaintsService.scientificRigourPlayers$;

  scientificRigourWorksheetColumns = [
    { header: 'Employee Id', key: 'employeeId', width: 50 } as Column,
    { header: 'Name', key: 'name', width: 50 } as Column,
    {
      header: 'Highest Score',
      key: 'highestScore',
      width: 15,
      alignment: { horizontal: 'center' },
    } as Column,
    { header: 'Completed Date', key: 'completedAt', width: 15 } as Column,
  ];

  constructor(private _asianPaintsService: AsianPaintsService) {
    _asianPaintsService.fetchScientificRigourPlayers();
  }

  ngOnInit(): void {
    console.log('Loaded');
  }

  tabChanged(event: any): void {
    console.log('Event: ', event);
  }
}
